module.exports = __webpack_public_path__ + "assets/23d8ac3cbcea81b97ca8862e5814d6d7.png";